module.exports = "/img/buttonU.d7a0a3cd.png";